// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the WhatsApp mark in its single-colour form: green ring,
// green handset, open middle. `mono` lets navigation tint it with currentColor.

import type React from 'react';

export function WhatsAppLogo({
	size = 16,
	style,
	mono = false,
}: {
	size?: number;
	style?: React.CSSProperties;
	mono?: boolean;
}) {
	const fill = mono ? 'currentColor' : '#25D366';
	return (
		<svg width={size} height={size} viewBox="0 0 32 32" style={style} aria-hidden="true">
			<path
				fill={fill}
				d="M16 3C8.8 3 3 8.7 3 15.7c0 2.5.7 4.9 2.1 7L3 29l6.5-2c2 1.1 4.2 1.6 6.5 1.6 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.4c-2 0-4-.5-5.7-1.6l-.4-.2-3.9 1.2 1.2-3.7-.3-.4a10.3 10.3 0 0 1-1.7-5.7C5.2 10 10 5.2 16 5.2s10.8 4.8 10.8 10.6S22 26.4 16 26.4z"
			/>
			<path
				fill={fill}
				d="M22 18.9c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2l-1 1.3c-.2.2-.4.2-.7.1a8.6 8.6 0 0 1-4.3-3.7c-.3-.6.3-.5.9-1.7.1-.2 0-.4 0-.6l-1-2.5c-.3-.6-.6-.5-.8-.5h-.7c-.2 0-.6.1-.9.4-.3.4-1.2 1.2-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.7 5.9 5.1 2.2.9 3 1 4.1.8.7-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6l-.7-.4z"
			/>
		</svg>
	);
}
